import countries from 'world-countries'

// Helper function to get flag emoji using Unicode
const getFlagEmoji = (countryCode) => {
  try {
    // Convert country code to Unicode flag emoji
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map((char) => 127397 + char.charCodeAt())
    return String.fromCodePoint(...codePoints)
  } catch (error) {
    console.warn(`Could not get flag for country ${countryCode}:`, error)
    return '🏳️' // fallback flag
  }
}

// Get all countries from world-countries library
const getCountryDataWithDialCodes = () => {
  return countries
    .filter((country) => country.callingCode && country.callingCode.length > 0) // Only countries with dial codes
    .map((country) => ({
      code: country.cca2.toLowerCase(), // Use 2-letter country code
      name: country.name.common, // Use common name
      dialCode: country.callingCode[0], // Use first calling code
      flag: getFlagEmoji(country.cca2), // Generate flag emoji
    }))
    .sort((a, b) => a.name.localeCompare(b.name)) // Sort alphabetically by name
}

// Process country data with translated names and flags
export const getProcessedCountryData = () => {
  const countryData = getCountryDataWithDialCodes()

  return countryData.map((country) => ({
    ...country,
    label: `${country.flag} ${country.name} (+${country.dialCode})`,
    value: country.code,
  }))
}

// Get dial code for a country
export const getDialCode = (countryCode) => {
  const countryData = getCountryDataWithDialCodes()
  const country = countryData.find((c) => c.code === countryCode)
  return country ? country.dialCode : '1'
}

// Get country by dial code
export const getCountryByDialCode = (dialCode) => {
  const countryData = getCountryDataWithDialCodes()
  return countryData.find((c) => c.dialCode === dialCode)
}
